export function Terms() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-bold tracking-tight">Terminos y condiciones</h1>
      <p className="mt-2 text-sm text-text-tertiary">
        Ultima actualizacion: 25/04/2026 — Borrador inicial.
      </p>

      <div className="prose prose-slate dark:prose-invert mt-8 max-w-none">
        <h2 className="mt-8 text-2xl font-bold">1. Naturaleza del servicio</h2>
        <p className="text-text-secondary">
          ExamsReactor es un <strong>simulador independiente de certificaciones cloud</strong> con
          fines de entrenamiento. NO es un examen oficial. NO esta afiliado oficialmente con
          Microsoft, Amazon Web Services ni ningun otro vendor cuyas certificaciones se simulen.
          Los nombres de examenes son marcas registradas de sus respectivos propietarios.
        </p>

        <h2 className="mt-8 text-2xl font-bold">2. Cuenta y elegibilidad</h2>
        <ul className="text-text-secondary">
          <li>Edad minima: <strong>18 anos cumplidos</strong>.</li>
          <li>Una sola cuenta por persona; cuentas compartidas estan prohibidas.</li>
          <li>Eres responsable de la confidencialidad de tu acceso.</li>
        </ul>

        <h2 className="mt-8 text-2xl font-bold">3. Suscripciones y pagos</h2>
        <p className="text-text-secondary">
          Las suscripciones premium se procesan via <strong>Paddle (Merchant of Record)</strong>.
          Los precios se muestran en USD y se cobran en moneda local cuando aplique. Paddle calcula
          y retiene impuestos locales (IGV/IVA/IPI/etc.) conforme corresponda.
        </p>

        <h2 className="mt-8 text-2xl font-bold">4. Politica de reembolso</h2>
        <p className="text-text-secondary">
          Tienes <strong>48 horas desde la compra o renovacion</strong> para solicitar reembolso
          completo desde /app/account. Mas alla de 48h se evaluara caso por caso a discrecion del
          equipo.
        </p>

        <h2 className="mt-8 text-2xl font-bold">5. Cancelacion</h2>
        <p className="text-text-secondary">
          Puedes cancelar tu suscripcion en cualquier momento. Mantienes acceso premium hasta el
          final del periodo pagado.
        </p>

        <h2 className="mt-8 text-2xl font-bold">6. Uso aceptable</h2>
        <ul className="text-text-secondary">
          <li>No reproducir, copiar, redistribuir ni publicar las preguntas del banco premium.</li>
          <li>No automatizar accesos (scraping, bots) sin autorizacion expresa.</li>
          <li>No compartir cuentas; el sistema detecta y restringe accesos sospechosos.</li>
        </ul>

        <h2 className="mt-8 text-2xl font-bold">7. Propiedad intelectual</h2>
        <p className="text-text-secondary">
          Todo el contenido (preguntas, explicaciones, reportes, codigo) es propiedad de
          ExamsReactor / Paul Marquina (o la SAC futura) y esta protegido por derechos de autor.
          Tu suscripcion te otorga una licencia de uso personal, no transferible.
        </p>

        <h2 className="mt-8 text-2xl font-bold">8. Limitacion de responsabilidad</h2>
        <p className="text-text-secondary">
          ExamsReactor entrega un servicio de entrenamiento "tal como esta". No garantizamos la
          aprobacion de ningun examen oficial. La responsabilidad maxima se limita al monto de tu
          suscripcion del ultimo mes.
        </p>

        <h2 className="mt-8 text-2xl font-bold">9. Ley aplicable</h2>
        <p className="text-text-secondary">
          Este contrato se rige por las leyes del Peru. Las disputas se resuelven primero por
          dialogo via correo y, en su defecto, en los tribunales de Lima.
        </p>

        <h2 className="mt-8 text-2xl font-bold">10. Libro de Reclamaciones</h2>
        <p className="text-text-secondary">
          Conforme a la normativa peruana de proteccion al consumidor, ofrecemos un{' '}
          <a href="/libro-de-reclamaciones" className="text-accent-primary hover:underline">
            Libro de Reclamaciones virtual
          </a>{' '}
          accesible 24/7.
        </p>

        <hr className="my-8 border-border-subtle" />

        <p className="text-xs text-text-tertiary">
          <strong>NOTA:</strong> Borrador inicial pendiente de revision legal antes de go-live
          (RC-LEGAL-002, Sprint 15).
        </p>
      </div>
    </div>
  );
}
